import React from 'react'

import Layout from '../components/Layout'
import {Bio} from '../components/Main'

const About = ({ location }) => {
    return (
        <Layout location={location}>
            <h1>About</h1>
            <Bio />
        </Layout>
    )
}

export default About
